module.exports = __webpack_public_path__ + "static/img/hero-land-bg.6d88ad8b.png";